/**
 * One-time station picker for the tablet. A shop-floor tablet is dedicated to a
 * station, so this shows once (or from the corner "change" affordance) with
 * clean icon cards; the choice sticks in localStorage via `useStation`.
 */
import { cn } from "@flint/ui";
import type { wip as wipContract } from "@flint/api-contract";
import { GARMENT_STATIONS } from "../../../lib/garment-stations.js";

export function StationPicker({
  onPick,
  title = "Set up this station",
}: {
  onPick: (stage: wipContract.WipStage) => void;
  title?: string;
}) {
  return (
    <div className="fixed inset-0 overflow-y-auto bg-bg">
      <div className="mx-auto w-full max-w-[720px] px-4 pb-8 pt-12">
        <div className="text-xs font-semibold uppercase tracking-[0.14em] text-muted">Station terminal</div>
        <h1 className="mt-2 text-2xl font-bold tracking-tight text-ink">{title}</h1>
        <p className="mt-1 text-sm text-muted">Tap your station. This tablet will remember it.</p>

        <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-3">
          {GARMENT_STATIONS.map((s) => (
            <button
              key={s.key}
              type="button"
              onClick={() => onPick(s.key)}
              className={cn(
                "group flex flex-col items-center gap-3 rounded-2xl border border-line bg-paper px-4 py-6 text-center shadow-card transition",
                "hover:border-line-2 active:scale-[0.98]",
              )}
            >
              <span className="grid h-14 w-14 place-items-center rounded-2xl bg-sky-50 text-sky-700 transition group-hover:bg-sky-100">
                <s.icon className="h-7 w-7" />
              </span>
              <span className="text-base font-semibold text-ink">{s.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
